import React from "react";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import FAQ from "../components/FAQ";
import ContactForm from "../components/ContactForm";
import { serviceFaqs } from "../mock";
import useSEO from "../hooks/useSEO";

const ServicesPage = () => {
  useSEO({
    title: "Roofing & Home Exterior Services Northern VA | Fab Build Pro",
    description: "Roof repair, roof replacement, storm damage repair, siding, windows, doors, gutters & remodeling from Fab Build Pro in Vienna, VA. Call 703-766-6599.",
    crumbs: [{ name: "Services", path: "/services" }],
  });
  return (
    <>
      <PageHero
        title="Our Services"
        subtitle="A full-service construction & roofing company offering comprehensive home improvement services across the DMV."
      />
      <Services withImages />
      <FAQ
        heading="Service FAQs"
        subtitle="Answers about siding, windows, gutters, doors, storm damage & remodeling."
        items={serviceFaqs}
      />
      <ContactForm />
    </>
  );
};

export default ServicesPage;
